import React from 'react';
import LeftImageRightContent from '../components/pttcourse/LeftImageRightContent';
import FourCardsSection from '../components/pttcourse/FourCardsSection';
import JoinCourseForm from '../components/JoinCourseForm';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_0575.JPG";
import SeoContentSection from "../components/SeoContentSection";


const NttCourse = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="Primary Teaching"
  subtitle="Empowering educators with practical skills and modern teaching methodologies"
 />
 <LeftImageRightContent />
 <FourCardsSection />
 <SeoContentSection title="Primary Teaching Course in Bangalore">
   <p>
     NIECCE's primary teaching course prepares aspiring and working educators to support children in the primary years. The program covers teaching methods, classroom planning, child development, communication, and practical activities for confident instruction.
   </p>
   <p>
     Learners can choose online or regular study options and benefit from theory sessions, practical exposure, value-added programs, certification, and placement assistance. This primary teacher training course is suitable for aspiring teachers, career changers, homemakers, and working educators.
   </p>
 </SeoContentSection>
 <JoinCourseForm />
    </>
  );
};

export default NttCourse;
